var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 7.2C3.6665 6.35131 4.00365 5.53737 4.60376 4.93726C5.20388 4.33714 6.01781 4 6.8665 4H16.4665C17.3152 4 18.1291 4.33714 18.7292 4.93726C19.3294 5.53737 19.6665 6.35131 19.6665 7.2V16.8C19.6665 17.6487 19.3294 18.4626 18.7292 19.0627C18.1291 19.6629 17.3152 20 16.4665 20H6.8665C6.01781 20 5.20388 19.6629 4.60376 19.0627C4.00365 18.4626 3.6665 17.6487 3.6665 16.8V7.2Z",
    stroke: "#44546F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8667 11.2031C9.97127 11.2031 10.8667 10.3077 10.8667 9.20312C10.8667 8.09856 9.97127 7.20312 8.8667 7.20312C7.76213 7.20312 6.8667 8.09856 6.8667 9.20312C6.8667 10.3077 7.76213 11.2031 8.8667 11.2031Z",
    stroke: "#44546F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 12.4963L6.8667 19.9995H16.5731C17.3936 19.9995 18.1804 19.6735 18.7606 19.0934C19.3408 18.5132 19.6667 17.7263 19.6667 16.9059V16.7995C19.6667 16.4267 19.5267 16.2835 19.2747 16.0075L16.0507 12.4915C15.9004 12.3275 15.7177 12.1968 15.514 12.1074C15.3104 12.0181 15.0904 11.9722 14.868 11.9727C14.6457 11.9731 14.4259 12.0199 14.2226 12.1101C14.0193 12.2002 13.8371 12.3317 13.6875 12.4963Z",
    stroke: "#44546F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument2);
export default __webpack_public_path__ + "static/media/document2.222cae56c5d47603fe068c5ee406e7ea.svg";
export { ForwardRef as ReactComponent };